module.exports = __webpack_public_path__ + "img/homepage-header.5738618f.png";